/* Keyless City car key kiosk: screen flow, data, idle timer, QR handoff. */
(function () {
  'use strict';

  var root = document.querySelector('[data-kiosk]');
  var dataEl = document.getElementById('KioskData');
  if (!root || !dataEl) return;

  var VERSION = '1.8';
  var DATA;
  try { DATA = JSON.parse(dataEl.textContent); } catch (e) { console.error('Kiosk data is not valid JSON', e); return; }
  var S = DATA.settings;
  var $ = function (sel, el) { return (el || root).querySelector(sel); };
  var $$ = function (sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); };

  var FLOW = ['service', 'brand', 'model', 'keytype', 'review', 'contact', 'location', 'pay'];
  var LABELS = ['Spare or lost', 'Brand', 'Model & year', 'Key type', 'Review', 'Contact', 'Location', 'Upload & pay'];
  var KEY_TYPES = {
    push_start: { title: 'Push to start', desc: 'You press a button to start the engine.' },
    ignition: { title: 'Turn key', desc: 'You put a key in and turn it.' },
    remote: { title: 'Remote', desc: 'A separate remote that locks and unlocks your doors.' }
  };
  var TYPE_ORDER = ['push_start', 'ignition', 'remote'];
  var BUILTIN_DELIVERY = [
    { id: 'pickup', kind: 'pickup', title: 'Pick up here', desc: 'We make your key, then you collect it from the pickup box at this kiosk.', details: "When your key is ready, we'll text and email you the box code.", for: 'spare', address: false, when: false, fee: null, enabled: true },
    { id: 'shop', kind: 'shop', title: 'Bring your car to our shop', desc: 'We program the key at your car.', details: '', for: 'both', address: false, when: false, fee: null, enabled: true },
    { id: 'mobile', kind: 'mobile', title: 'We come to you', desc: 'A technician comes to your car, at home or at work.', details: '', for: 'both', address: true, when: true, fee: null, enabled: true }
  ];
  var DELIVERY = (S.delivery && S.delivery.length ? S.delivery : BUILTIN_DELIVERY);
  function deliveryOptions() {
    var svc = state.service;
    return DELIVERY.filter(function (o) { return o.enabled && (o.for === 'both' || o.for === svc); });
  }
  function chosenDelivery() { return DELIVERY.filter(function (o) { return o.id === state.location; })[0] || null; }
  function docsRequired() { return isLost() ? !!S.docsForLost : !!S.docsForSpare; }

  var state, current = 'start';

  function fresh() {
    return { service: null, make: null, model: null, year: null, models: null, years: null, keys: null, keyType: null, product: null,
      qty: 1, orderName: '', contact: null, location: null, address: null, when: 'asap', session: null, q: { brand: '', model: '' } };
  }

  /* ---------- helpers ---------- */
  function el(tag, attrs, children) {
    var n = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === 'text') n.textContent = attrs[k];
      else if (k === 'class') n.className = attrs[k];
      else if (k.indexOf('on') === 0) n.addEventListener(k.slice(2), attrs[k]);
      else n.setAttribute(k, attrs[k]);
    });
    (children || []).forEach(function (c) { if (c) n.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return n;
  }
  function svg(markup) { var d = document.createElement('div'); d.innerHTML = markup; return d.firstChild; }
  var fmt;
  try { fmt = new Intl.NumberFormat(S.locale || 'en-US', { style: 'currency', currency: S.currency || 'USD' }); }
  catch (e) { fmt = { format: function (n) { return '$' + n.toFixed(2); } }; }
  function money(cents) { return fmt.format((cents || 0) / 100); }
  function uniq(arr) { return arr.filter(function (v, i) { return arr.indexOf(v) === i; }); }
  function sortAlpha(a, b) { return a.localeCompare(b); }
  function isLost() { return state.service === 'lost'; }
  function carName() { return [state.year && state.year.name, state.make && state.make.name, state.model && state.model.name].filter(Boolean).join(' '); }
  function b64url(str) {
    var bytes = new TextEncoder().encode(str), bin = '';
    bytes.forEach(function (b) { bin += String.fromCharCode(b); });
    return btoa(bin).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }

  /* ---------- this device's signing key (WebCrypto) ----------
     Each browser that opens the kiosk makes its own ECDSA P-256 key the first time. The private key
     is non-extractable (it can sign, but can't be read or copied) and is kept in IndexedDB. The admin
     knows the device by the fingerprint of its public key and decides which device is which kiosk.
     Without WebCrypto or IndexedDB (e.g. a private window) the kiosk still works; its reports are
     just unsigned and not counted as any kiosk. */
  function b64(buf) { var s = '', a = new Uint8Array(buf); for (var i = 0; i < a.length; i++) s += String.fromCharCode(a[i]); return btoa(s); }
  function base32(buf) {
    var A = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567', a = new Uint8Array(buf), bits = 0, val = 0, out = '';
    for (var i = 0; i < a.length; i++) { val = (val << 8) | a[i]; bits += 8; while (bits >= 5) { out += A[(val >>> (bits - 5)) & 31]; bits -= 5; } }
    return out;
  }
  function idb(mode, fn) {
    return new Promise(function (resolve, reject) {
      var open = indexedDB.open('keyless-kiosk', 1);
      open.onupgradeneeded = function () { open.result.createObjectStore('device'); };
      open.onerror = function () { reject(open.error); };
      open.onblocked = function () { reject(new Error('IndexedDB blocked')); };
      open.onsuccess = function () {
        var tx = open.result.transaction('device', mode), req = fn(tx.objectStore('device'));
        tx.oncomplete = function () { resolve(req.result); };
        tx.onerror = function () { reject(tx.error); };
      };
    });
  }
  var deviceInit = (function () {
    if (!window.crypto || !crypto.subtle || !window.indexedDB) return Promise.resolve(null);
    return idb('readonly', function (st) { return st.get('key'); }).then(function (rec) {
      if (rec && rec.privateKey && rec.spki) return rec;
      return crypto.subtle.generateKey({ name: 'ECDSA', namedCurve: 'P-256' }, false, ['sign', 'verify']).then(function (keys) {
        return crypto.subtle.exportKey('spki', keys.publicKey).then(function (spki) {
          return crypto.subtle.digest('SHA-256', spki).then(function (hash) {
            var rec2 = { privateKey: keys.privateKey, spki: b64(spki), id: base32(hash).slice(0, 16) };
            return idb('readwrite', function (st) { return st.put(rec2, 'key'); }).then(function () { return rec2; });
          });
        });
      });
    }).then(function (rec) {
      DEVICE = { id: rec.id, code: rec.id.slice(0, 4) + '-' + rec.id.slice(4, 8), privateKey: rec.privateKey, spki: rec.spki };
      showIdentity();
      return DEVICE;
    }).catch(function () { return null; });   // no key: unsigned reports
  })();
  // Never let a slow or stuck key store hold back reports: wait at most 4 s, then send unsigned
  // until the key is ready (DEVICE is set as soon as it is, and later reports are signed).
  var deviceReady = Promise.race([deviceInit, new Promise(function (r) { setTimeout(function () { r(null); }, 4000); })]);
  var DEVICE = null;     // { id, code, privateKey, spki }
  var ASSIGNED = null;   // { id, name, location } once the admin assigns this device to a kiosk
  // The kiosk ID written on orders and sessions: the admin's assignment, else this device's code,
  // else the theme setting (no WebCrypto).
  function kioskLabel() {
    if (ASSIGNED) return ASSIGNED.id;
    if (DEVICE) return 'D-' + DEVICE.id.slice(0, 8);
    return String(S.kioskId || 'K1');
  }

  /* ---------- reports to the kiosk admin (heartbeats, sessions, issues) ---------- */
  // Never sends the customer's name, phone, email or address. Signed with the device key.
  var API = String(S.adminUrl || '').trim().replace(/\/+$/, '').replace(/\/status$/, '');
  function report(type, extra) {
    if (!API) return Promise.resolve(null);
    // Built now, so it describes the moment of the event even though signing is async.
    var body = JSON.stringify(Object.assign({ k: S.kioskId, s: state && state.session, type: type, v: VERSION, ts: Date.now() }, extra || {}));
    return (DEVICE ? Promise.resolve(DEVICE) : deviceReady).then(function (dev) {
      if (!dev) return body;
      return crypto.subtle.sign({ name: 'ECDSA', hash: 'SHA-256' }, dev.privateKey, new TextEncoder().encode(body))
        .then(function (sig) { return JSON.stringify({ pk: dev.spki, sig: b64(sig), body: body }); })
        .catch(function () { return body; });
    }).then(function (text) {
      return fetch(API + '/kiosk/event', { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: text, keepalive: true, credentials: 'omit' });
    }).then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });   // reporting must never break the kiosk
  }
  var logged = 0;
  function logIssue(level, code, msg, ctx) {
    if (++logged > 50) return;   // per page load; the kiosk reloads nightly
    report('log', { level: level, code: code, msg: String(msg || '').slice(0, 500), ctx: ctx || null });
  }
  // Errors from other sites' scripts (Shopify apps, chat, analytics loaded on the page) reach us only as
  // "Script error." with no file or line: the browser hides the details. They aren't kiosk errors, so
  // they're logged once per page load as info. Errors from our own code keep their details.
  var thirdPartyLogged = false;
  function thirdParty(detail) {
    if (thirdPartyLogged) return;
    thirdPartyLogged = true;
    logIssue('info', 'third_party_script_error', 'A script from another site (a Shopify app on the page) failed. Not a kiosk error.', detail || null);
  }
  window.addEventListener('error', function (e) {
    var file = String(e.filename || '');
    if (!file || (e.message === 'Script error.' && !e.lineno)) return thirdParty();
    if (!/kiosk/.test(file)) return thirdParty({ file: file.split('?')[0].split('/').slice(-2).join('/'), msg: String(e.message || '').slice(0, 120) });
    logIssue('error', 'js_error', e.message, { file: file.split('/').pop(), line: e.lineno, col: e.colno });
  });
  window.addEventListener('unhandledrejection', function (e) {
    var r = e.reason, stack = String(r && r.stack || '');
    if (!/kiosk\.js/.test(stack)) return thirdParty({ msg: String(r && r.message || r).slice(0, 120) });
    logIssue('error', 'js_error', 'Unhandled: ' + (r && r.message || r), { stack: stack.split('\n').slice(0, 3).join(' | ') });
  });
  function newSession() {
    var rnd = '';
    try { var b = new Uint8Array(6); crypto.getRandomValues(b); b.forEach(function (x) { rnd += ('0' + x.toString(16)).slice(-2); }); }
    catch (e) { rnd = Math.random().toString(16).slice(2, 14); }
    return kioskLabel().replace(/[^A-Za-z0-9]/g, '') + '-' + Date.now().toString(36).toUpperCase() + '-' + rnd.toUpperCase();
  }
  // What the admin shows for a session: the choices so far, no personal details.
  function sessionData() {
    return { svc: state.service, car: carName() || null, kn: state.product ? state.product.title : null, kt: state.keyType, q: state.product ? state.qty : null };
  }
  function heartbeat() {
    var fullyId = null;
    try { if (window.fully && typeof fully.getDeviceId === 'function') fullyId = fully.getDeviceId(); } catch (e) {}
    report('heartbeat', { scr: current, data: state.session ? sessionData() : null, mem: navigator.deviceMemory || null,
      up: Math.round(performance.now() / 1000), w: window.screen && screen.width, h: window.screen && screen.height, fully: fullyId })
      .then(applyRemote);
  }

  /* ---------- settings from the admin: checkout method, kiosk access, pricing ----------
     Cached so a reload starts with the last known settings (and stays blocked if it was). */
  function stored(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function store(k, v) { try { localStorage.setItem(k, v); } catch (e) { /* private window */ } }
  var CONFIG = (function () { try { return JSON.parse(stored('kiosk-config')) || {}; } catch (e) { return {}; } })();
  var cachedKiosk = stored('kiosk-assigned') || '';
  var KNOWN = false;           // the admin has told us whether this device is assigned
  var deviceFailed = false;    // this browser can't make a device key (unsigned)
  // Kiosk look (admin → Settings): "classic" navy + orange, or "key2go" yellow + black (kiosk.css).
  function applyTheme() {
    document.documentElement.setAttribute('data-kiosk-theme', CONFIG.theme === 'key2go' ? 'key2go' : 'classic');
  }
  applyTheme();
  function applyConfig(cfg) {
    if (!cfg || typeof cfg !== 'object') return;
    CONFIG = cfg;
    store('kiosk-config', JSON.stringify(cfg));
    applyTheme();
    applyKioskState();
  }
  if (API) {
    fetch(API + '/kiosk/config', { credentials: 'omit', cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; }).then(applyConfig).catch(function () {});
  }
  deviceInit.then(function (dev) { if (!dev) { deviceFailed = true; applyKioskState(); } });

  /* ---------- commands from the admin: identity, maintenance mode, reload ---------- */
  var REMOTE = { maintenance: false, message: '', reloadSeq: null, pendingReload: false, forceReload: false };
  function applyRemote(d) {
    if (!d) return;
    if (d.config) { CONFIG = d.config; store('kiosk-config', JSON.stringify(d.config)); applyTheme(); }
    if (!d.device) {
      if (deviceFailed) { KNOWN = true; ASSIGNED = null; applyKioskState(); }
      return;
    }
    KNOWN = true;
    ASSIGNED = d.kiosk || null;
    store('kiosk-assigned', ASSIGNED ? ASSIGNED.id : '');
    showIdentity();
    REMOTE.maintenance = !!(d.maintenance && d.maintenance.on);
    REMOTE.message = (d.maintenance && d.maintenance.message) || '';
    if (d.reload) {
      // The first answer after the page loads is the baseline; a higher number later means "reload".
      if (REMOTE.reloadSeq === null) REMOTE.reloadSeq = d.reload.seq;
      else if (d.reload.seq > REMOTE.reloadSeq) { REMOTE.reloadSeq = d.reload.seq; REMOTE.pendingReload = true; REMOTE.forceReload = !!d.reload.force; }
    }
    applyKioskState();
  }
  function isIdle() { return current === 'start' || current === 'done'; }
  var applying = false;
  function applyKioskState() {
    if (applying || !state) return;
    applying = true;
    try {
      // Reload: right away if forced, otherwise when no customer is using the kiosk.
      if (REMOTE.pendingReload && (REMOTE.forceReload || isIdle() || REMOTE.maintenance)) {
        if (state.session && !isIdle()) report('session_end', { reason: 'start_over' });
        setTimeout(function () { location.reload(); }, 300);
        return;
      }
      // "Only registered kiosks": a device that isn't assigned to a kiosk can't be used.
      // Until the admin answers, trust the last known assignment on this device.
      var blockBox = $('[data-blocked]');
      var blocked = !!CONFIG.block && (KNOWN ? !ASSIGNED : !cachedKiosk);
      if (blocked && current !== 'pay') {
        $('[data-blocked-code]').textContent = DEVICE ? DEVICE.code : (deviceFailed ? 'none' : '…');
        $('[data-blocked-why]').textContent = DEVICE || !deviceFailed
          ? 'Staff: open the kiosk admin → Kiosks → Devices and assign this device code to a kiosk. This screen goes away within about 15 seconds.'
          : 'This browser can’t create a device key (for example a private window), so it can’t be registered. Use the kiosk app on the tablet.';
        if (blockBox.hidden) {
          if (!isIdle()) reset('start_over'); else closeModals();
          blockBox.hidden = false;
          Voice.stop();
        }
        return;
      } else if (!blocked && !blockBox.hidden) {
        blockBox.hidden = true;
        touch();
      }

      var box = $('[data-maint]');
      // Maintenance never interrupts a customer who is paying; it starts when they leave that screen.
      if (REMOTE.maintenance && current !== 'pay') {
        $('[data-maint-text]').textContent = REMOTE.message || 'This kiosk is temporarily out of service.';
        if (box.hidden) {
          if (!isIdle()) reset('maintenance'); else closeModals();
          box.hidden = false;
          Voice.stop();
        }
      } else if (!REMOTE.maintenance && !box.hidden) {
        box.hidden = true;
        touch();
      }
    } finally { applying = false; }
  }
  // Small label so staff can match a screen to the admin: "Front entrance · K1" or "Device 7K4Q-Q9MZ · not assigned".
  function showIdentity() {
    var text = ASSIGNED ? [ASSIGNED.name || ('Kiosk ' + ASSIGNED.id), ASSIGNED.location, ASSIGNED.id].filter(Boolean).join(' · ')
      : DEVICE ? 'Device ' + DEVICE.code + ' · not assigned' : '';
    $$('[data-ident]').forEach(function (e) { e.textContent = text; });
  }

  /* ---------- voice guidance ---------- */
  var V = S.voice || {};
  var Voice = (function () {
    var fully = window.fully && typeof window.fully.textToSpeech === 'function' ? window.fully : null;
    var synth = !fully && 'speechSynthesis' in window ? window.speechSynthesis : null;
    var chosen = null;
    function pickVoice() {
      if (!synth || chosen) return chosen;
      var lang = String(V.lang || 'en-US').toLowerCase();
      var list = synth.getVoices() || [];
      chosen = list.filter(function (v) { return v.lang && v.lang.toLowerCase() === lang; })[0]
        || list.filter(function (v) { return v.lang && v.lang.toLowerCase().indexOf(lang.split('-')[0]) === 0; })[0] || null;
      return chosen;
    }
    if (synth && 'onvoiceschanged' in synth) synth.onvoiceschanged = function () { chosen = null; pickVoice(); };
    return {
      available: !!(fully || synth),
      on: false,
      speak: function (text) {
        if (!this.on || !text) return;
        this.stop();
        if (fully) { try { fully.textToSpeech(text, V.lang || 'en-US'); } catch (e) {} return; }
        try {
          var u = new SpeechSynthesisUtterance(text);
          u.lang = V.lang || 'en-US'; u.rate = Number(V.rate) || 1;
          var v = pickVoice(); if (v) u.voice = v;
          synth.speak(u);
        } catch (e) { /* never let speech break the kiosk */ }
      },
      stop: function () {
        try { if (fully && typeof fully.stopTextToSpeech === 'function') fully.stopTextToSpeech(); else if (synth) synth.cancel(); } catch (e) {}
      }
    };
  })();
  function setVoice(on) {
    Voice.on = !!on && Voice.available;
    var b = $('[data-action="voice"]');
    b.setAttribute('aria-pressed', String(Voice.on));
    $('[data-voice-label]').textContent = Voice.on ? 'Voice on' : 'Voice off';
    if (!Voice.on) Voice.stop();
  }
  function listWords(arr) { return arr.length < 2 ? arr.join('') : arr.slice(0, -1).join(', ') + ' or ' + arr[arr.length - 1]; }
  // What the kiosk says on each screen. Never reads out the customer's name, phone or email.
  function spokenFor(name) {
    switch (name) {
      case 'start': return 'Welcome to ' + (document.querySelector('.k-start__name') || {}).textContent + '. Touch the screen to start.';
      case 'service': return 'What do you need? Choose spare key if you have a working key, or lost key if you don\'t.' + (S.docsForLost ? ' For a lost key, you will need a photo I D and your registration.' : '');
      case 'brand': return 'What is your car brand? Tap your brand, or type it in the search box.';
      case 'model': return 'Which ' + state.make.name + '? First tap your model, then pick the year from the list, then tap continue.';
      case 'keytype':
        var keys = state.keys || [];
        if (state.keyType) return 'Tap the key that looks like yours.';
        var has = function (t) { return keys.some(function (p) { return p.type === t; }); };
        var types = TYPE_ORDER.filter(has).map(function (t) { return KEY_TYPES[t].title; });
        var out = TYPE_ORDER.filter(function (t) { return !has(t); }).map(function (t) { return KEY_TYPES[t].title; });
        return types.length ? 'Which key do you need? You can choose ' + listWords(types) + '.' + (out.length ? ' ' + listWords(out).replace(' or ', ' and ') + (out.length > 1 ? ' were' : ' was') + ' not found for this car.' : '')
          : 'Sorry, we don\'t have a key for this car at the kiosk. Tap need help, and our team will help you.';
      case 'review': return 'Review your order. ' + state.product.title.replace(/\s*\/\s*/g, ', ') + '. Total ' + $('[data-t="total"]').textContent + '. Use plus or minus to change how many keys, then tap continue.';
      case 'contact': return 'Please enter your full name, your mobile number and your email, then tap continue.';
      case 'location': return 'Where do you need us? You can choose ' + listWords(deliveryOptions().map(function (o) { return o.title; })) + '.';
      case 'pay': return 'Scan the Q R code with your phone camera. ' + (docsRequired() ? 'Upload a photo of your I D and your registration, then pay on your phone.' : 'Then pay on your phone.') + ' Your total is ' + $('[data-pay-total]').textContent + '.';
      case 'done': return 'You\'re all set. Thank you!' + (state.orderName ? ' Your order number is ' + state.orderName.replace('#', '') + '.' : '') + ' We will text you when your key is ready.';
      case 'nokeys': return 'Sorry, we couldn\'t find a key for a ' + carName() + '. You can change the year or model, change the brand, change spare or lost key, or get help from our team.';
      case 'timeout': return 'Do you need more time? Tap yes to keep going.';
      case 'help': return 'Need help? You can call us, text us, or visit the counter. Tap back to my order when you\'re ready.';
      default: return '';
    }
  }

  /* ---------- navigation ---------- */
  function go(name) {
    if (name !== 'pay' && typeof stopPaymentCheck === 'function') stopPaymentCheck();
    closePopups();
    current = name;
    root.dataset.screen = name;
    $('[data-screen-id="start"]').hidden = name !== 'start';
    $('[data-screen-id="done"]').hidden = name !== 'done';
    $$('.k-screen').forEach(function (s) { s.hidden = s.dataset.screenId !== name; });
    if (FLOW.indexOf(name) !== -1) renderSteps();
    if (RENDER[name]) RENDER[name]();
    if (state.session && name !== 'start' && name !== 'pay') report('screen', { scr: name, data: sessionData() });   // pay reports qr_shown
    touch();
    applyKioskState();   // a reload or maintenance mode that waited for the customer to finish
    if (Voice.on) { try { Voice.speak(spokenFor(name)); } catch (e) {} }
  }
  function next() {
    var i = FLOW.indexOf(current);
    if (i !== -1 && i < FLOW.length - 1) go(FLOW[i + 1]);
  }
  function back() {
    if (current === 'keytype' && state.keyType) { state.keyType = null; RENDER.keytype(); return; }
    if (current === 'review' && state.keyType && (state.keys || []).filter(function (p) { return p.type === state.keyType; }).length < 2) state.keyType = null;
    var i = FLOW.indexOf(current);
    go(i <= 0 ? 'start' : FLOW[i - 1]);
  }
  function reset(reason) {
    closeModals();
    clearInterval(doneTimer);
    if (state.session) report('session_end', { reason: state.manualPaid ? 'manual_paid' : reason || 'start_over' });
    state = fresh();
    $$('form', root).forEach(function (f) { f.reset(); });
    $$('[data-search]').forEach(function (i) { i.value = ''; });
    $$('[aria-invalid]').forEach(function (i) { i.removeAttribute('aria-invalid'); });
    $$('.k-error').forEach(function (e) { e.hidden = true; });
    setVoice(!!V.defaultOn);
    go('start');
  }

  function stepValue(i) {
    switch (FLOW[i]) {
      case 'service': return state.service === 'lost' ? 'Lost key' : 'Spare key';
      case 'brand': return state.make && state.make.name;
      case 'model': return [state.model && state.model.name, state.year && state.year.name].filter(Boolean).join(', ');
      case 'keytype': return state.keyType && KEY_TYPES[state.keyType] ? KEY_TYPES[state.keyType].title : '';
      case 'review': return state.qty + (state.qty === 1 ? ' key' : ' keys');
      case 'contact': return 'Added';
      case 'location': var d = chosenDelivery(); return d ? d.title : '';
      default: return '';
    }
  }
  function renderSteps() {
    var list = $('[data-steps]'), at = FLOW.indexOf(current);
    list.textContent = '';
    LABELS.forEach(function (label, i) {
      var done = i < at, now = i === at;
      list.appendChild(el('li', { class: 'k-step' + (done ? ' is-done' : '') + (now ? ' is-current' : ''), 'aria-current': now ? 'step' : 'false' }, [
        el('span', { class: 'k-step__dot', 'aria-hidden': 'true', text: done ? '✓' : String(i + 1) }),
        el('span', { class: 'k-step__text' }, [
          el('span', { class: 'k-step__label', text: label }),
          done ? el('span', { class: 'k-step__value', text: stepValue(i) || '' }) : null
        ])
      ]));
    });
  }

  /* ---------- choice cards ---------- */
  function choiceCard(opts) {
    var art = el('span', { class: 'k-choice__art', 'aria-hidden': 'true' });
    if (opts.art) art.appendChild(opts.art);
    var attrs = { type: 'button', class: 'k-choice' + (opts.disabled ? ' is-disabled' : '') };
    if (opts.disabled) attrs.disabled = 'disabled';
    else attrs.onclick = opts.onclick;
    return el('button', attrs, [
      art,
      el('span', { class: 'k-choice__text' }, [
        opts.tag ? el('span', { class: 'k-choice__tag' + (opts.disabled ? ' k-choice__tag--off' : ''), text: opts.tag }) : null,
        el('span', { class: 'k-choice__title', text: opts.title }),
        el('span', { class: 'k-choice__desc', text: opts.desc })
      ])
    ]);
  }
  // Animated art for the Spare / Lost cards (styles in kiosk.css, "Spare / lost scenes").
  // Spare: one key gets scanned, then a copy slides out next to it.
  // Lost: the key falls into an open street manhole, then a "?" pops up.
  function keyPicture(variant) {
    var key = function (cls) { return el('img', { class: 'k-scene__key ' + cls, src: S.keyImage, alt: '' }); };
    if (variant === 'spare') {
      return el('span', { class: 'k-scene k-scene--spare' }, [
        key('k-dup__copy'), key('k-dup__orig'),
        el('span', { class: 'k-dup__scan' }),
        el('span', { class: 'k-dup__plus', text: '+' })
      ]);
    }
    return el('span', { class: 'k-scene k-scene--lost' }, [
      el('span', { class: 'k-street' }, [el('span', { class: 'k-street__line' })]),
      el('span', { class: 'k-manhole' }),
      el('span', { class: 'k-manhole__cover' }),
      el('span', { class: 'k-fall' }, [el('span', { class: 'k-fall__mover' }, [key('k-fall__key')])]),
      el('span', { class: 'k-manhole__puff' }),
      el('span', { class: 'k-lost__q', text: '?' })
    ]);
  }
  var TYPE_ART = {
    push_start: '<svg viewBox="0 0 120 120" fill="none"><circle cx="60" cy="60" r="50" fill="#fff" stroke="#D9DFEA" stroke-width="4"/><circle cx="60" cy="60" r="38" style="fill:var(--navy)"/><path d="M60 42v14" stroke="#fff" stroke-width="4" stroke-linecap="round"/><path d="M51 47a14 14 0 1 0 18 0" stroke="#fff" stroke-width="4" stroke-linecap="round"/><text x="60" y="84" text-anchor="middle" fill="#A9B8D6" font-family="Archivo,sans-serif" font-weight="700" font-size="8">START</text></svg>',
    ignition: '<svg viewBox="0 0 120 120" fill="none"><circle cx="60" cy="60" r="50" fill="#fff" stroke="#D9DFEA" stroke-width="4"/><circle cx="60" cy="60" r="34" style="fill:var(--navy)"/><rect x="56" y="38" width="8" height="44" rx="2" style="fill:var(--navy-2)"/><g transform="rotate(35 60 60)"><rect x="52" y="20" width="16" height="22" rx="5" style="fill:var(--accent)"/><rect x="57" y="40" width="6" height="34" fill="#B8C2D4"/></g><path d="M92 34a40 40 0 0 1 6 18" style="stroke:var(--accent)" stroke-width="3" stroke-linecap="round"/></svg>',
    remote: '<svg viewBox="0 0 120 120" fill="none"><circle cx="60" cy="60" r="50" fill="#fff" stroke="#D9DFEA" stroke-width="4"/><rect x="40" y="26" width="40" height="70" rx="16" style="fill:var(--navy)"/><circle cx="60" cy="20" r="7" style="stroke:var(--navy)" stroke-width="3"/><rect x="49" y="38" width="22" height="13" rx="4" fill="#fff"/><rect x="49" y="56" width="22" height="13" rx="4" fill="#fff"/><rect x="49" y="74" width="22" height="11" rx="4" style="fill:var(--accent)"/><path d="M88 40a14 14 0 0 1 0 20M94 34a22 22 0 0 1 0 32" style="stroke:var(--accent)" stroke-width="3" stroke-linecap="round"/></svg>'
  };

  /* ---------- car data: Search Filter YMM app ---------- */
  var logos = {};
  DATA.brands.forEach(function (b) { if (b.name) logos[b.name.toLowerCase()] = b.logo; });
  var hidden = (S.hiddenMakes || []).map(function (m) { return m.trim().toLowerCase(); }).filter(Boolean);
  var exclude = (S.excludeWords || []).map(function (w) { return w.trim().toLowerCase(); }).filter(Boolean);
  function makes() {
    return (DATA.makes || []).filter(function (m) { return m && m.field_val && hidden.indexOf(m.field_val.toLowerCase()) === -1; })
      .map(function (m) { return { tag: m.tag_val, name: m.field_val }; });
  }
  var cache = {};
  function ymm(params) {
    var key = JSON.stringify(params);
    if (cache[key]) return Promise.resolve(cache[key]);
    var q = new URLSearchParams(Object.assign({ domain: S.ymm.domain, lang_code: 'en', pri_lang_code: 'en' }, params));
    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 12000) : null;
    return fetch(S.ymm.endpoint + '?' + q.toString(), ctrl ? { signal: ctrl.signal } : {})
      .then(function (r) { if (!r.ok) throw new Error('YMM ' + r.status); return r.json(); })
      .then(function (d) { clearTimeout(timer); cache[key] = d; return d; })
      .catch(function (e) { clearTimeout(timer); throw e; });
  }
  function options(html) {
    var doc = new DOMParser().parseFromString(String(html || '').split('~')[0], 'text/html');
    return Array.prototype.slice.call(doc.querySelectorAll('option'))
      .filter(function (o) { return o.value && o.value !== '-1'; })
      .map(function (o) { return { tag: o.value, name: o.textContent.trim() }; });
  }
  function loadModels(make) {
    return ymm({ load: 'all', data_filter: 'updated', action: 'onchange', use_cart_info_ftr: 'no', version: 'updated', ver_no: '3',
      current_field: 'field_2', prev_val: make.tag, current_val: make.tag }).then(function (d) { return options(d.html); })
      .catch(function (e) { logIssue('warn', 'ymm_models_failed', 'Car search failed loading models: ' + e.message, { make: make.name }); throw e; });
  }
  function loadYears(make, model) {
    return ymm({ load: 'all', data_filter: 'updated', action: 'onchange', use_cart_info_ftr: 'no', version: 'updated', ver_no: '3',
      current_field: 'field_3', prev_val: make.tag + ',' + model.tag, current_val: model.tag })
      .then(function (d) { return options(d.html).sort(function (a, b) { return Number(b.name) - Number(a.name); }); })
      .catch(function (e) { logIssue('warn', 'ymm_years_failed', 'Car search failed loading years: ' + e.message, { make: make.name, model: model.name }); throw e; });
  }
  function keyTypeOf(p) {
    var hay = (p.title + ' | ' + (p.tags || []).join(' | ')).toLowerCase();
    if (/smart key|proximity/.test(hay)) return 'push_start';
    if (/keyless entry remote/.test(hay)) return 'remote';
    if (/transponder|remote head|flip key|fobik|metal head|plastic head/.test(hay)) return 'ignition';
    return null;
  }
  function toProduct(p) {
    var v = (p.variants && p.variants.edges || []).map(function (e) { return e.node; })
      .filter(function (n) { return n.availableForSale; })[0];
    var title = String(p.title || '');
    var dbg = function (r) { if (/[?&]debug=1/.test(location.search)) console.info('[kiosk] HIDE ' + title + ' → ' + r); return null; };
    if (!v) return dbg('out of stock');
    var low = title.toLowerCase();
    var word = exclude.filter(function (w) { return low.indexOf(w) !== -1; })[0];
    if (word) return dbg('hidden word "' + word + '"');
    if ((p.tags || []).some(function (t) { return /bundle/i.test(t); })) return dbg('bundle tag');
    var type = keyTypeOf(p);
    var img = p.featuredImage && p.featuredImage.url ? p.featuredImage.url.replace(/_\d+x\d+(\.\w+)$/, '_400x400$1') : null;
    return {
      id: p.id, handle: p.handle, type: type, image: img,
      title: title.replace(/\s*\(aftermarket\)\s*/i, '').trim(),
      variant: { id: Number(String(v.id).split('/').pop()), price: Math.round(parseFloat(v.price) * 100) }
    };
  }
  /* ---------- collection checks (after the word checks) ---------- */
  var F = S.filters || {};
  function cleanList(arr) { return (arr || []).map(function (x) { return String(x).trim(); }).filter(Boolean); }
  var ALLOWED = cleanList(F.allowed).map(function (line) {
    var parts = line.split(':');
    return { handle: parts[0].trim().toLowerCase(), type: (parts[1] || '').trim().toLowerCase() };
  }).filter(function (x) { return x.handle && KEY_TYPES[x.type]; });
  var BLOCKED = cleanList(F.blocked).map(function (h) { return h.toLowerCase(); });
  var BLOCKED_HANDLES = cleanList(F.blockedHandles).map(function (h) { return h.toLowerCase(); });
  var infoCache = {};
  function productInfo(handle) {
    if (infoCache[handle]) return infoCache[handle];
    infoCache[handle] = Promise.resolve().then(function () { return fetch('/products/' + encodeURIComponent(handle) + '?view=kiosk-data', { credentials: 'same-origin' }); })
      .then(function (r) { if (!r.ok) throw new Error('info ' + r.status); return r.text(); })
      .then(function (t) {
        var d = JSON.parse(t);
        if (!d || !Array.isArray(d.collections)) throw new Error('kiosk-data template missing or wrong shape');
        return d;
      })
      .catch(function () { delete infoCache[handle]; return null; });
    return infoCache[handle];
  }
  var DEBUG = /[?&]debug=1/.test(location.search);
  function why(p, reason) { if (DEBUG) console.info('[kiosk] ' + (reason === 'shown' ? 'SHOW ' : 'HIDE ') + p.title + ' → ' + reason); }
  function applyCollections(p, info) {
    if (BLOCKED_HANDLES.indexOf(String(p.handle).toLowerCase()) !== -1) { why(p, 'blocked product list'); return null; }
    if (F.minPrice && p.variant.price < F.minPrice) { why(p, 'price below minimum'); return null; }
    if (F.maxPrice && p.variant.price > F.maxPrice) { why(p, 'price above maximum'); return null; }
    if (!info) { why(p, p.type ? 'shown' : 'no key words (collection lookup failed)'); return p.type ? p : null; }
    if ((info.tags || []).some(function (t) { return /^not for kiosk$/i.test(String(t).trim()); })) { why(p, 'tagged Not for kiosk'); return null; }
    var cols = (info.collections || []).map(function (h) { return String(h).toLowerCase(); });
    var blockedBy = cols.filter(function (h) { return BLOCKED.indexOf(h) !== -1; })[0];
    if (blockedBy) { why(p, 'blocked collection ' + blockedBy); return null; }
    var hit = ALLOWED.filter(function (a) { return cols.indexOf(a.handle) !== -1; })[0];
    if (hit) { p.type = hit.type; p.matchedBy = 'collection:' + hit.handle; why(p, 'shown'); return p; }
    if (F.requireAllowed && ALLOWED.length) { why(p, 'not in an allowed collection (' + cols.join(', ') + ')'); return null; }
    why(p, p.type ? 'shown' : 'no key words'); return p.type ? p : null;
  }
  function loadKeys(make, model, year) {
    var tags = [make.tag, model.tag, year.tag].join(',');
    function page(n, acc) {
      return ymm({ action: 'get_products', tags: tags, current: String(n), limit: '50', currency: S.currency || 'USD',
        front_domain: S.ymm.frontDomain, dbl_score: 'yes', route_url: '/', market_id: S.ymm.marketId || '', country_code: S.ymm.country || 'US',
        sale_lbl: 'Sale', soldout_lbl: 'Soldout', img_dimension: '400x400', show_sku: 'no', show_vendor: 'no' })
        .then(function (d) {
          var got = d.ymm_products || [];
          acc = acc.concat(got);
          var total = Number(d.total) || 0;
          var more = got.length > 0 && (total ? acc.length < total : got.length >= 50);
          return more && n < 10 ? page(n + 1, acc) : acc;
        });
    }
    return page(1, []).then(function (list) {
      var seen = {};
      var candidates = list.map(toProduct).filter(function (p) { if (!p || seen[p.id]) return false; seen[p.id] = true; return true; });
      return Promise.all(candidates.map(function (p) { return productInfo(p.handle); })).then(function (infos) {
        var failed = infos.filter(function (x) { return !x; }).length;
        if (failed) logIssue('warn', 'lookup_failed', failed + ' of ' + candidates.length + ' product lookups failed', { car: [year.name, make.name, model.name].join(' ') });
        return candidates.map(function (p, i) { return applyCollections(p, infos[i]); }).filter(Boolean);
      });
    }, function (e) {
      logIssue('warn', 'ymm_keys_failed', 'Car search failed loading keys: ' + e.message, { car: [year.name, make.name, model.name].join(' ') });
      throw e;
    });
  }
  /* ---------- kiosk pricing rules (set in the kiosk admin → Settings) ----------
     Same formula as the server (kiosk-admin/worker/pricing.js), in cents:
       range  min + (max − min) × clamp(key ÷ reach, 0, 1)    (reach 0 = max)
       add    key + amount
     then never below the website price (option) and rounding up to $1 / $5 (option). */
  function priceRule() {
    var p = CONFIG && CONFIG.pricing, r = p && p[isLost() ? 'lost' : 'spare'];
    return r && (r.mode === 'range' || r.mode === 'add') ? r : null;
  }
  function kioskUnit(keyCents) {
    var p = CONFIG.pricing, r = priceRule(), unit;
    if (r.mode === 'add') unit = keyCents + r.add;
    else { var reach = r.reach > 0 ? r.reach : r.max; unit = r.min + Math.min(Math.max(keyCents / reach, 0), 1) * (r.max - r.min); }
    if (p.never_below_web !== false) unit = Math.max(unit, keyCents);
    unit = Math.round(unit);
    if (p.rounding === 'dollar') unit = Math.ceil(unit / 100) * 100;
    if (p.rounding === 'five') unit = Math.ceil(unit / 500) * 500;
    return unit;
  }
  // Cutting and programming per key. With a pricing rule it is (kiosk price − key price): exact with
  // draft-order checkout; with cart checkout, the service product's price step at or above it.
  function serviceFee() {
    if (state.product && priceRule()) {
      var target = kioskUnit(state.product.variant.price) - state.product.variant.price;
      if (CONFIG.checkout === 'draft') return { variantId: null, price: target };
      var F3 = S.serviceFees || {}, c3 = isLost() ? F3.lost : F3.spare;
      var st = (c3 && c3.variants || []).filter(function (v) { return v.available; }).sort(function (a, b) { return a.price - b.price; });
      if (!st.length) { logIssue('warn', 'fee_steps_missing', 'Pricing rule needs the ' + (isLost() ? 'lost' : 'spare') + ' key service product (theme editor) for cart checkout.'); return null; }
      var p3 = st.filter(function (v) { return v.price >= target - 1; })[0];
      if (!p3) {
        p3 = st[st.length - 1];
        logIssue('warn', 'fee_steps_short', 'Pricing rule needs a ' + (isLost() ? 'lost' : 'spare') + ' key service price step of ' + money(target) +
          ', but the highest is ' + money(p3.price) + '. The kiosk charges less than the rule. Add higher price steps, or use draft-order checkout.');
      }
      return { variantId: p3.id, price: p3.price, target: target };
    }
    return themeServiceFee();
  }
  // Without a pricing rule: the theme's service fee settings.
  // Scaled fee = min + clamp((key − low) / (high − low)) × (max − min); then the closest price step at or above it.
  function themeServiceFee() {
    var F2 = S.serviceFees || {}, cfg = isLost() ? F2.lost : F2.spare;
    if (!cfg || !cfg.variants || !cfg.variants.length) return null;
    var steps = cfg.variants.filter(function (v) { return v.available; }).sort(function (a, b) { return a.price - b.price; });
    if (!steps.length) return null;
    if (F2.mode !== 'scaled' || !(cfg.max > cfg.min) || !(F2.keyHigh > F2.keyLow) || !state.product) {
      return { variantId: steps[0].id, price: steps[0].price };
    }
    var t = (state.product.variant.price - F2.keyLow) / (F2.keyHigh - F2.keyLow);
    t = Math.min(Math.max(t, 0), 1);
    var target = cfg.min + t * (cfg.max - cfg.min);
    var pick = steps.filter(function (v) { return v.price >= target - 1; })[0] || steps[steps.length - 1];
    return { variantId: pick.id, price: pick.price, target: Math.round(target) };
  }
  function unitPrice() { var f = serviceFee(); return state.product.variant.price + (f ? f.price : 0); }

  /* ---------- screens ---------- */
  var RENDER = {
    service: function () {
      var box = $('[data-service-options]'); box.textContent = '';
      if (S.enableSpare) box.appendChild(choiceCard({ art: keyPicture('spare'), title: 'Spare key', desc: 'I have a working key and want another one.', tag: S.docsForSpare ? 'Photo ID + registration needed' : null,
        onclick: function () { state.service = 'spare'; next(); } }));
      if (S.enableLost) box.appendChild(choiceCard({ art: keyPicture('lost'), title: 'Lost key', desc: "I don't have a working key for this car.", tag: S.docsForLost ? 'Photo ID + registration needed' : null,
        onclick: function () { state.service = 'lost'; next(); } }));
    },
    brand: function () {
      var grid = $('[data-brand-grid]'), q = state.q.brand.trim().toLowerCase(); grid.textContent = '';
      var list = makes().filter(function (m) { return !q || m.name.toLowerCase().indexOf(q) !== -1; });
      list.forEach(function (m) {
        var logo = logos[m.name.toLowerCase()];
        grid.appendChild(el('button', { type: 'button', class: 'k-tile k-tile--brand' + (logo ? '' : ' no-logo'),
          onclick: function () {
            if (!state.make || state.make.tag !== m.tag) { state.model = null; state.year = null; state.models = null; state.years = null; state.keys = null; }
            state.make = m; next();
          } },
          logo ? [el('img', { src: logo, alt: '', loading: 'lazy' }), el('small', { text: m.name })] : [m.name]));
      });
      $('[data-brand-empty]').hidden = list.length > 0;
      $('[data-clear="brand"]').hidden = !q;
    },
    model: function () {
      $('[data-model-title]').textContent = 'Which ' + state.make.name + ', and what year?';
      $('[data-search-error]').hidden = true;
      var status = $('[data-model-status]'), grid = $('[data-model-grid]');
      if (!state.models) {
        grid.textContent = ''; status.hidden = false; status.textContent = 'Loading models…';
        var mk = state.make;
        loadModels(mk).then(function (list) { if (state.make !== mk) return; state.models = list; RENDER.model(); })
          .catch(function () { if (state.make !== mk) return; status.textContent = 'Car search is unavailable right now. Tap “Need help?” and our team will help you.'; });
        renderYears(); summary(); return;
      }
      var q = state.q.model.trim().toLowerCase(); grid.textContent = '';
      var list = state.models.filter(function (m) { return !q || m.name.toLowerCase().indexOf(q) !== -1; });
      status.hidden = list.length > 0; status.textContent = 'No model matches. Tap “Need help?” and we\'ll help you.';
      list.forEach(function (m) {
        grid.appendChild(el('button', { type: 'button', class: 'k-tile', 'aria-pressed': String(!!state.model && state.model.tag === m.tag), text: m.name,
          onclick: function () { state.model = m; state.year = null; state.years = null; state.keys = null; yearOpenWhenLoaded = true; RENDER.model(); } }));
      });
      $('[data-clear="model"]').hidden = !q;
      renderYears(); summary();
    },
    keytype: function () {
      var box = $('[data-keytype-options]'), list = $('[data-key-list]'); box.textContent = ''; list.textContent = '';
      var keys = state.keys || [];
      $('[data-keytype-sub]').textContent = state.keyType ? 'Pick the key that looks like yours.' : 'Only options that fit a ' + carName() + ' are shown.';
      if (state.keyType) {
        box.hidden = true; list.hidden = false;
        keys.filter(function (p) { return p.type === state.keyType; }).forEach(function (p) {
          list.appendChild(el('button', { type: 'button', class: 'k-keyitem', onclick: function () { state.product = p; state.qty = 1; next(); } }, [
            el('span', { class: 'k-keyitem__img', 'aria-hidden': 'true' }, [el('img', { src: p.image || S.keyImage, alt: '', loading: 'lazy' })]),
            el('span', { class: 'k-keyitem__title', text: p.title })
          ]));
        });
        $('[data-keytype-empty]').hidden = true;
        return;
      }
      box.hidden = false; list.hidden = true;
      // All three types are always shown; types with no matching key are greyed out as "Not found for this car".
      // (No key at all never reaches this screen: findKeys shows the "We couldn't find a key" popup.)
      var types = TYPE_ORDER.filter(function (t) { return keys.some(function (p) { return p.type === t; }); });
      $('[data-keytype-empty]').hidden = types.length > 0;
      if (types.length < TYPE_ORDER.length) $('[data-keytype-sub]').textContent = 'Options for a ' + carName() + '. Grey options were not found for this car.';
      TYPE_ORDER.forEach(function (t) {
        var inStock = types.indexOf(t) !== -1;
        box.appendChild(choiceCard({ art: svg(TYPE_ART[t]), title: KEY_TYPES[t].title, desc: KEY_TYPES[t].desc,
          disabled: !inStock, tag: inStock ? null : 'Not found for this car',
          onclick: function () {
            state.keyType = t;
            var ofType = keys.filter(function (p) { return p.type === t; });
            if (ofType.length === 1) { state.product = ofType[0]; state.qty = 1; next(); }
            else { RENDER.keytype(); Voice.speak(spokenFor('keytype')); }
          } }));
      });
    },
    review: function () {
      var p = state.product, fee = serviceFee();
      var img = $('[data-review-img]'); img.textContent = '';
      img.appendChild(el('img', { src: p.image || S.keyImage, alt: '' }));
      $('[data-review-title]').textContent = p.title;
      $('[data-review-meta]').textContent = carName() + ' · ' + (isLost() ? 'Lost key' : 'Spare key');
      var unit = unitPrice(), sub = unit * state.qty, tax = Math.round(sub * (S.taxRate || 0) / 100);
      $('[data-qty-val]').textContent = state.qty;
      $('[data-qty="-1"]').disabled = state.qty <= 1;
      $('[data-qty="1"]').disabled = state.qty >= (S.maxQty || 3);
      $('[data-t="part"]').textContent = money(p.variant.price);
      $('[data-t-service-row]').hidden = !fee;
      if (fee) $('[data-t="service"]').textContent = money(fee.price);
      $('[data-t="unit"]').textContent = money(unit);
      $('[data-t="qty"]').textContent = '× ' + state.qty;
      $('[data-t="sub"]').textContent = money(sub);
      $('[data-t="taxLabel"]').textContent = 'Estimated tax (' + (S.taxRate || 0) + '%)';
      $('[data-t="tax"]').textContent = money(tax);
      $('[data-t="total"]').textContent = money(sub + tax);
    },
    contact: function () {},
    location: function () {
      var box = $('[data-location-options]'); box.textContent = '';
      var opts = deliveryOptions();
      if (!opts.some(function (o) { return o.id === state.location; })) state.location = opts[0] ? opts[0].id : null;
      opts.forEach(function (o) {
        var tag = o.fee ? '+ ' + money(o.fee.price) : 'Free';
        box.appendChild(el('button', { type: 'button', role: 'radio', class: 'k-option', 'aria-checked': String(state.location === o.id),
          onclick: function () { state.location = o.id; RENDER.location(); } }, [
          el('span', { class: 'k-option__radio', 'aria-hidden': 'true' }),
          el('span', { class: 'k-option__text' }, [el('strong', { text: o.title }), el('span', { text: o.desc || '' })]),
          el('span', { class: 'k-option__tag' + (o.fee ? ' is-fee' : ''), text: tag })
        ]));
      });
      var d = chosenDelivery();
      $('[data-location-detail]').hidden = !d;
      if (d) {
        $('[data-detail-title]').textContent = d.title;
        $('[data-detail-text]').textContent = d.details || '';
        $('[data-detail-text]').hidden = !d.details;
        $('[data-detail-address]').hidden = !d.address;
        $('[data-detail-when]').hidden = !d.when;
      }
      $$('[data-when-val]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.whenVal === state.when)); });
      $('[data-location-error]').hidden = true;
      if (!opts.length) { $('[data-location-error]').textContent = 'No delivery option is available for this order. Tap “Need help?”'; $('[data-location-error]').hidden = false; }
      $('[data-next-location]').disabled = !state.location;
    },
    pay: function () {
      if (!state.session) state.session = newSession();
      var dlv = chosenDelivery();
      var feeCents = dlv && dlv.fee ? dlv.fee.price : 0;
      var sub = unitPrice() * state.qty + feeCents;
      var total = sub + Math.round(sub * (S.taxRate || 0) / 100);
      $('[data-pay-total]').textContent = money(total);
      $('[data-pay-sub]').textContent = docsRequired()
        ? 'Scan once. Upload your documents, then pay, all on your phone.'
        : 'Scan once and pay on your phone.';
      $('[data-pay-note]').textContent = 'Estimated total. The exact tax is shown at checkout.';
      var list = $('[data-checklist]'); list.textContent = '';
      var items = docsRequired()
        ? [['Photo ID', "Driver's license or state ID"], ['Registration or title', 'The name must match your ID'], ['Pay', 'Card, Apple Pay or Google Pay']]
        : [['Check your order', 'Your key, car and contact details'], ['Pay', 'Card, Apple Pay or Google Pay']];
      items.forEach(function (it, i) {
        list.appendChild(el('li', null, [el('span', { class: 'k-checklist__n', text: String(i + 1) }),
          el('span', { class: 'k-checklist__t' }, [el('strong', { text: it[0] }), el('span', { text: it[1] })])]));
      });
      var fee = serviceFee();
      var order = {
        t: Date.now(), k: kioskLabel(), s: state.session, v: state.product.variant.id, q: state.qty, svc: state.service,
        kn: state.product.title, car: carName(), kt: state.keyType, loc: state.location,
        n: state.contact.name, p: state.contact.phone, e: state.contact.email
      };
      if (fee && fee.variantId) order.sv = fee.variantId;
      order.d = docsRequired() ? 1 : 0;
      order.cm = CONFIG.checkout === 'draft' && API ? 'draft' : 'cart';
      if (order.cm === 'draft') order.x = API;   // the phone page needs the admin even if its own setting is empty
      if (CONFIG.theme === 'key2go') order.th = 'key2go';   // the phone page matches the kiosk's look
      if (dlv) {
        order.ln = dlv.title;
        if (dlv.address) order.a = state.address;
        if (dlv.when) order.w = state.when;
        if (dlv.fee) order.f = dlv.fee.variantId;
      }
      var phoneOrigin = order.cm === 'draft' && CONFIG.phoneDomain ? 'https://' + CONFIG.phoneDomain : S.origin;
      drawQR($('[data-qr]'), phoneOrigin + S.phonePagePath + '?o=' + b64url(JSON.stringify(order)));
      // The admin compares this quote with what Shopify charged; draft-order checkout builds the order
      // from it (signed by this device), so the QR link on the phone can't change what is charged.
      report('qr_shown', { data: Object.assign(sessionData(), { sub: sub, total: total, loc: dlv ? dlv.title : null, d: order.d,
        order: { v: order.v, q: order.q, svc: order.svc, sv: order.sv || null, f: order.f || null, ln: order.ln || null, d: order.d,
          kt: order.kt, kn: order.kn, car: order.car, unit: unitPrice(), key: state.product.variant.price } }) });
      startPaymentCheck();
    }
  };

  /* ---------- payment check (needs the payment worker) ---------- */
  var payTimer = null, payFails = 0;
  function stopPaymentCheck() { clearTimeout(payTimer); payTimer = null; }
  function startPaymentCheck() {
    stopPaymentCheck(); payFails = 0;
    var box = $('[data-pay-status]'), manual = $('[data-pay-manual]');
    box.classList.remove('is-paid');
    manual.hidden = false; manual.disabled = false; manual.textContent = 'I’ve paid on my phone';
    if (!API) { box.hidden = true; return; }
    box.hidden = false;
    $('[data-pay-status-text]').textContent = 'Waiting for your payment…';
    var session = state.session;
    (function poll() {
      fetch(API + '/status?s=' + encodeURIComponent(session), { cache: 'no-store' })
        .then(function (r) { if (!r.ok) throw new Error('status ' + r.status); return r.json(); })
        .then(function (d) {
          if (current !== 'pay' || state.session !== session) return;
          payFails = 0;
          if (d && d.paid) {
            box.classList.add('is-paid');
            $('[data-pay-status-text]').textContent = 'Payment received' + (d.order ? ' (order ' + d.order + ')' : '') + '.';
            state.orderName = d.order || '';
            setTimeout(function () { if (current === 'pay') { go('done'); startDoneTimer(); } }, 1500);
            return;
          }
          payTimer = setTimeout(poll, 3000);
        })
        .catch(function () {
          if (current !== 'pay' || state.session !== session) return;
          payFails += 1;
          if (payFails === 5) logIssue('warn', 'status_unreachable', 'Payment check failed 5 times; the “I’ve paid” button can’t verify payment.');
          payTimer = setTimeout(poll, 5000);
        });
    })();
  }

  /*
   * "I've paid on my phone": ask the admin whether this session is paid before moving on.
   * Only when there is no way to check (no admin address, or the admin can't be reached) does the
   * kiosk trust the customer; that is logged so staff can check the order exists in Shopify.
   */
  function confirmPaid() {
    var btn = $('[data-pay-manual]'), box = $('[data-pay-status]'), text = $('[data-pay-status-text]');
    var session = state.session;
    function trustCustomer(why) {
      logIssue('info', 'manual_paid', 'Customer tapped “I’ve paid on my phone” and payment could not be checked (' + why + ').');
      state.manualPaid = true;
      go('done'); startDoneTimer();
    }
    if (!API) { trustCustomer('no kiosk admin address'); return; }
    btn.disabled = true; btn.textContent = 'Checking your payment…';
    fetch(API + '/status?s=' + encodeURIComponent(session), { cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('status ' + r.status); return r.json(); })
      .then(function (d) {
        if (current !== 'pay' || state.session !== session) return;
        btn.disabled = false; btn.textContent = 'I’ve paid on my phone';
        if (d && d.paid) {
          state.orderName = d.order || '';
          box.hidden = false; box.classList.add('is-paid');
          text.textContent = 'Payment received' + (d.order ? ' (order ' + d.order + ')' : '') + '.';
          go('done'); startDoneTimer();
          return;
        }
        box.hidden = false; box.classList.remove('is-paid');
        text.textContent = 'We haven’t received your payment yet. Finish paying on your phone; this screen moves on by itself when it arrives.';
        Voice.speak('We haven\'t received your payment yet. Please finish paying on your phone.');
        logIssue('info', 'paid_tap_unconfirmed', 'Customer tapped “I’ve paid on my phone” but no payment has arrived for this session yet.');
      })
      .catch(function (e) {
        if (current !== 'pay' || state.session !== session) return;
        btn.disabled = false; btn.textContent = 'I’ve paid on my phone';
        trustCustomer('admin unreachable: ' + e.message);
      });
  }

  /* ---------- year: dropdown with a search box ---------- */
  var yearOpenWhenLoaded = false;
  function setYearButton(text, disabled) {
    var btn = $('[data-year-toggle]');
    $('[data-year-label]').textContent = text;
    btn.disabled = disabled;
    btn.classList.toggle('has-value', !disabled && !!state.year);
    if (disabled) openYears(false);
  }
  function renderYears() {
    if (!state.model) { setYearButton('Pick your model first', true); return; }
    if (!state.years) {
      setYearButton('Loading years…', true);
      var md = state.model;
      loadYears(state.make, md).then(function (list) {
        if (state.model !== md) return;
        state.years = list; renderYears(); summary();
        if (yearOpenWhenLoaded && current === 'model') openYears(true);   // picking a model opens the year list
        yearOpenWhenLoaded = false;
      }).catch(function () { if (state.model !== md) return; setYearButton('Years are unavailable. Tap “Need help?”', true); });
      return;
    }
    if (!state.years.length) { setYearButton('No years found for this model', true); return; }
    setYearButton(state.year ? state.year.name : 'Select year', false);
    if (!$('[data-year-pop]').hidden) renderYearList();
  }
  function renderYearList() {
    var list = $('[data-year-list]'), q = $('[data-year-q]').value.replace(/\D/g, '');
    list.textContent = '';
    var years = (state.years || []).filter(function (y) { return !q || String(y.name).indexOf(q) !== -1; });
    years.forEach(function (y) {
      var on = !!state.year && state.year.tag === y.tag;
      list.appendChild(el('button', { type: 'button', role: 'option', class: 'k-select__opt', 'aria-selected': String(on), text: y.name,
        onclick: function () { state.year = y; state.keys = null; openYears(false); renderYears(); summary(); } }));
    });
    $('[data-year-none]').hidden = years.length > 0;
  }
  function openYears(open) {
    var pop = $('[data-year-pop]'), btn = $('[data-year-toggle]');
    if (!pop) return;
    if (open && btn.disabled) return;
    if (open === !pop.hidden) return;
    pop.hidden = !open;
    btn.setAttribute('aria-expanded', String(open));
    if (!open) return;
    $('[data-year-q]').value = '';
    renderYearList();
    // Open upwards when there isn't room below (in portrait the year box sits low on the screen).
    var rem = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
    var r = btn.getBoundingClientRect(), need = 42 * rem;
    $('[data-year-select]').classList.toggle('is-up', window.innerHeight - r.bottom < need && r.top > window.innerHeight - r.bottom);
    var sel = $('[data-year-list] [aria-selected="true"]');
    if (sel) sel.scrollIntoView({ block: 'nearest' });
  }
  function summary() {
    $('[data-model-summary]').textContent = state.model ? (state.make.name + ' ' + state.model.name + (state.year ? ', ' + state.year.name : '')) : 'Choose your model';
    $('[data-next-model]').disabled = !state.year;
  }
  function findKeys() {
    var btn = $('[data-next-model]'), err = $('[data-search-error]');
    btn.disabled = true; btn.textContent = 'Finding keys…'; err.hidden = true;
    var y = state.year;
    loadKeys(state.make, state.model, state.year).then(function (keys) {
      btn.textContent = 'Continue';
      if (state.year !== y) return;
      state.keys = keys; state.keyType = null; state.product = null;
      if (!keys.length) { showNoKeys(); return; }
      next();
    }).catch(function () {
      btn.textContent = 'Continue'; btn.disabled = false;
      err.textContent = 'We couldn\'t look up keys right now. Please try again, or tap “Need help?”'; err.hidden = false;
    });
  }

  function showNoKeys() {
    $('[data-nokeys-text]').textContent = 'We don\'t have a key for a ' + carName() + ' at the kiosk right now.';
    $('[data-nokeys-car]').textContent = 'Now: ' + [state.model && state.model.name, state.year && state.year.name].filter(Boolean).join(', ');
    $('[data-nokeys-brand]').textContent = 'Now: ' + (state.make ? state.make.name : '');
    $('[data-nokeys-service]').textContent = 'Now: ' + (isLost() ? 'Lost key' : 'Spare key');
    $('[data-next-model]').disabled = false;
    logIssue('info', 'no_keys', 'No kiosk key for a ' + carName(), { service: state.service });
    openModal('nokeys');
  }

  function drawQR(box, text) {
    box.textContent = '';
    if (typeof window.QRCode !== 'function') {
      box.appendChild(el('p', { class: 'k-muted', text: 'QR code unavailable. Please ask our team for help.' }));
      logIssue('error', 'qr_unavailable', 'The QR code library did not load.');
      return;
    }
    new window.QRCode(box, { text: text, width: 512, height: 512, correctLevel: window.QRCode.CorrectLevel.M });
  }

  /* ---------- forms ---------- */
  $('[data-contact-form]').addEventListener('submit', function (e) {
    e.preventDefault();
    var f = e.target, err = $('[data-contact-error]'), bad = [];
    var fName = f.elements.namedItem('name'), fPhone = f.elements.namedItem('phone'), fEmail = f.elements.namedItem('email');
    var name = fName.value.trim(), phone = fPhone.value.replace(/\D/g, ''), email = fEmail.value.trim();
    fName.setAttribute('aria-invalid', String(name.length < 2)); if (name.length < 2) bad.push('your name');
    fPhone.setAttribute('aria-invalid', String(phone.length < 10)); if (phone.length < 10) bad.push('a 10-digit mobile number');
    var okEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    fEmail.setAttribute('aria-invalid', String(!okEmail)); if (!okEmail) bad.push('a valid email');
    if (bad.length) { err.textContent = 'Please enter ' + bad.join(', ') + '.'; err.hidden = false; return; }
    err.hidden = true;
    state.contact = { name: name, phone: phone, email: email };
    next();
  });

  /* ---------- street address suggestions (Photon / OpenStreetMap) ---------- */
  var AC = S.address || {};
  var acTimer = null, acSeq = 0;
  function acClose() {
    clearTimeout(acTimer); acSeq++;
    var list = $('[data-ac-list]'), input = $('[data-ac-input]');
    if (list) { list.hidden = true; list.textContent = ''; }
    if (input) input.setAttribute('aria-expanded', 'false');
  }
  // Houston-area box around the "near" point, so results stay local.
  function acArea() {
    var p = String(AC.near || '').split(',').map(Number);
    if (p.length !== 2 || !isFinite(p[0]) || !isFinite(p[1])) return null;
    return { lat: p[0], lon: p[1], bbox: [p[1] - 0.8, p[0] - 0.7, p[1] + 0.8, p[0] + 0.7].map(function (n) { return n.toFixed(3); }).join(',') };
  }
  function acSearch(text) {
    var mine = ++acSeq, area = acArea();
    var q = new URLSearchParams({ q: text, limit: '8', lang: 'en' });
    if (area) { q.set('lat', area.lat); q.set('lon', area.lon); q.set('bbox', area.bbox); }
    q.append('layer', 'house'); q.append('layer', 'street');
    // OpenStreetMap often has the street but not the house number: keep the number the customer typed.
    var typedNumber = (text.match(/^\s*(\d+[A-Za-z]?)\b/) || [])[1] || '';
    // The street words typed (without the number and words like "st"), so "1200 main st" only
    // suggests streets with "main" in the name, not every street nearby.
    var words = text.replace(/^\s*\d+[A-Za-z]?\s*/, '').toLowerCase().split(/[\s,]+/).filter(function (w) {
      return w.length > 1 && !/^(st|street|dr|drive|rd|road|ave|av|avenue|blvd|boulevard|ln|lane|fwy|freeway|hwy|pkwy|ct|way|tx|houston)$/.test(w);
    });
    fetch(AC.endpoint + '?' + q.toString(), { credentials: 'omit' })
      .then(function (r) { if (!r.ok) throw new Error('address search ' + r.status); return r.json(); })
      .then(function (d) {
        if (mine !== acSeq) return;
        var seen = {}, items = [];
        (d.features || []).forEach(function (f) {
          var p = f.properties || {};
          if (p.countrycode && p.countrycode !== 'US') return;
          var road = p.street || p.name;
          if (!road) return;
          var roadLow = road.toLowerCase();
          if (words.length && !words.every(function (w) { return roadLow.indexOf(w) !== -1; })) return;
          if (typedNumber && p.housenumber && String(p.housenumber).indexOf(typedNumber) !== 0) return;
          var number = p.housenumber || typedNumber;
          var item = { street: (number ? number + ' ' : '') + road, city: p.city || p.town || p.village || p.district || '', zip: String(p.postcode || '').slice(0, 5), state: p.state || '' };
          var key = (item.street + '|' + item.city + '|' + item.zip).toLowerCase();
          if (seen[key]) return;
          seen[key] = true; items.push(item);
        });
        acRender(items.slice(0, 5));
      })
      .catch(function (e) { if (mine === acSeq) acClose(); logIssue('warn', 'address_search_failed', e.message); });
  }
  function acRender(items) {
    var list = $('[data-ac-list]'), input = $('[data-ac-input]');
    list.textContent = '';
    if (!items.length) { list.hidden = true; input.setAttribute('aria-expanded', 'false'); return; }
    items.forEach(function (it) {
      list.appendChild(el('button', { type: 'button', role: 'option', class: 'k-ac__opt', onclick: function () { acPick(it); } }, [
        el('strong', { text: it.street }),
        el('span', { text: [it.city, [it.state === 'Texas' ? 'TX' : it.state, it.zip].filter(Boolean).join(' ')].filter(Boolean).join(', ') })
      ]));
    });
    list.hidden = false;
    input.setAttribute('aria-expanded', 'true');
  }
  var acPicked = null;   // the last suggestion tapped, to keep its state (TX…) for checkout
  function acPick(it) {
    acPicked = it;
    var f = $('[data-address-form]');
    f.elements.namedItem('street').value = it.street;
    if (it.city) f.elements.namedItem('city').value = it.city;
    if (it.zip) f.elements.namedItem('zip').value = it.zip;
    ['street', 'city', 'zip'].forEach(function (n) { f.elements.namedItem(n).removeAttribute('aria-invalid'); });
    $('[data-location-error]').hidden = true;
    acClose();
  }
  (function () {
    var input = $('[data-ac-input]');
    if (!input) return;
    input.addEventListener('input', function () {
      clearTimeout(acTimer);
      var text = input.value.trim();
      if (!AC.enabled || !AC.endpoint || text.length < 4) { acClose(); return; }
      acTimer = setTimeout(function () { acSearch(text); }, 300);
    });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') acClose(); });
  })();

  /* Close the year list and address suggestions (screen change, outside tap, reset). */
  function closePopups() { openYears(false); acClose(); }
  document.addEventListener('pointerdown', function (e) {
    if (!e.target.closest('[data-year-select]')) openYears(false);
    if (!e.target.closest('.k-ac')) acClose();
  });

  function locationNext() {
    var d = chosenDelivery();
    if (!d) return;
    if (d.address) {
      var f = $('[data-address-form]'), err = $('[data-location-error]');
      var fe = function (n) { return f.elements.namedItem(n); };
      var a = { street: fe('street').value.trim(), city: fe('city').value.trim(), zip: fe('zip').value.trim() };
      var missing = [];
      [['street', 'street address'], ['city', 'city'], ['zip', 'ZIP code']].forEach(function (x) {
        var empty = !a[x[0]] || (x[0] === 'zip' && !/^\d{5}$/.test(a.zip));
        fe(x[0]).setAttribute('aria-invalid', String(empty)); if (empty) missing.push(x[1]);
      });
      if (missing.length) { err.textContent = 'Please enter your ' + missing.join(', ') + '.'; err.hidden = false; return; }
      // State for the checkout form: from the tapped suggestion, otherwise Texas (the service area).
      var picked = acPicked && acPicked.street === a.street ? acPicked.state : '';
      a.state = !picked || /^texas$/i.test(picked) ? 'TX' : picked;
      state.address = a;
    } else { state.address = null; }
    next();
  }

  /* ---------- modals + idle ---------- */
  var lastTouch = Date.now(), countdown = 0, doneTimer;
  function touch() { lastTouch = Date.now(); }
  function openModal(name) { $('[data-modal="' + name + '"]').hidden = false; Voice.speak(spokenFor(name)); }
  function closeModals() { var was = $$('.k-modal').some(function (m) { return !m.hidden; }); $$('.k-modal').forEach(function (m) { m.hidden = true; }); countdown = 0; if (was) Voice.stop(); }
  function modalOpen(name) { return !$('[data-modal="' + name + '"]').hidden; }
  function openHelp() {
    $$('[data-help-qr]').forEach(function (b) { if (!b.firstChild) drawQR(b, b.dataset.helpQr); });
    logIssue('info', 'help_opened', 'Customer opened “Need help?” on ' + current, { screen: current });
    openModal('help');
  }
  setInterval(function () {
    if (current === 'start' || current === 'done') return;
    if (modalOpen('help')) { touch(); return; }
    var ring = $('[data-ring]');
    if (modalOpen('timeout')) {
      countdown -= 1;
      $('[data-countdown]').textContent = Math.max(countdown, 0);
      ring.style.strokeDashoffset = String(565.5 * (1 - Math.max(countdown, 0) / S.countdownSeconds));
      if (countdown <= 0) reset('timeout');
      return;
    }
    var limit = S.idleSeconds * (current === 'pay' ? 4 : 1) * 1000;
    if (Date.now() - lastTouch > limit) {
      countdown = S.countdownSeconds;
      $('[data-countdown]').textContent = countdown;
      ring.style.strokeDashoffset = '0';
      openModal('timeout');
    }
  }, 1000);

  function showDoneOrder() {
    $('[data-done-order]').textContent = state.orderName ? 'Order ' + state.orderName + ' is paid. Your receipt is on your phone.' : 'Your receipt is on your phone.';
  }
  function startDoneTimer() {
    showDoneOrder();
    var left = S.doneSeconds || 20, label = $('[data-done-timer]');
    label.textContent = 'Back to the start in ' + left + ' seconds.';
    clearInterval(doneTimer);
    doneTimer = setInterval(function () {
      left -= 1;
      label.textContent = 'Back to the start in ' + left + ' seconds.';
      if (left <= 0) { clearInterval(doneTimer); reset('done'); }
    }, 1000);
  }

  /* ---------- events ---------- */
  ['pointerdown', 'keydown'].forEach(function (t) { document.addEventListener(t, function () { if (!modalOpen('timeout')) touch(); }, { passive: true }); });
  document.addEventListener('contextmenu', function (e) { e.preventDefault(); });

  root.addEventListener('click', function (e) {
    var a = e.target.closest('[data-action]');
    if (a) switch (a.dataset.action) {
      case 'start': state = fresh(); state.session = newSession(); report('session_start'); go('service'); return;
      case 'back': back(); return;
      case 'next':
        if (current === 'location') locationNext();
        else if (current === 'model') findKeys();
        else next();
        return;
      case 'reset': reset(current === 'done' ? 'done' : 'start_over'); return;
      case 'nokeys-year': closeModals(); touch(); state.year = null; state.keys = null; RENDER.model(); openYears(true); return;
      case 'nokeys-brand': closeModals(); state.model = null; state.year = null; state.models = null; state.years = null; state.keys = null; go('brand'); return;
      case 'nokeys-service': closeModals(); state.keys = null; go('service'); return;
      case 'nokeys-help': closeModals(); openHelp(); return;
      case 'voice':
        setVoice(!Voice.on);
        if (Voice.on) {
          var open = $$('.k-modal').filter(function (m) { return !m.hidden; })[0];
          Voice.speak(open ? spokenFor(open.dataset.modal) : spokenFor(current));
        }
        return;
      case 'help': openHelp(); return;
      case 'close-help': closeModals(); touch(); return;
      case 'more-time': closeModals(); touch(); return;
      case 'edit': go('review'); return;
      case 'finished': confirmPaid(); return;
    }
    var q = e.target.closest('[data-qty]');
    if (q) { state.qty = Math.min(Math.max(1, state.qty + Number(q.dataset.qty)), S.maxQty || 3); RENDER.review(); return; }
    var w = e.target.closest('[data-when-val]');
    if (w) { state.when = w.dataset.whenVal; RENDER.location(); return; }
    var c = e.target.closest('[data-clear]');
    if (c) { var k = c.dataset.clear; state.q[k] = ''; $('[data-search="' + k + '"]').value = ''; RENDER[k](); return; }
    if (e.target.closest('[data-year-toggle]')) openYears($('[data-year-pop]').hidden);
  });
  $('[data-year-q]').addEventListener('input', renderYearList);
  $('[data-year-q]').addEventListener('keydown', function (e) { if (e.key === 'Escape') openYears(false); });
  $$('[data-search]').forEach(function (input) {
    input.addEventListener('input', function () { state.q[input.dataset.search] = input.value; RENDER[input.dataset.search](); });
  });

  state = fresh();
  $('[data-action="voice"]').hidden = !(V.show && Voice.available);
  setVoice(!!V.defaultOn);
  go('start');
  heartbeat();
  setInterval(heartbeat, 15000);   // also how quickly admin commands (reload, maintenance) arrive
})();
